// Recursos que dependem de permissao concedida na App Review do app da Meta.
//
// Diferente de FEATURE_KEYS/plugins (que dizem o que ESTE cliente contratou),
// aqui e o que o APP consegue pedir a Meta. Enquanto a permissao nao sai, a
// Meta devolve o token sem o escopo — o dialogo nao falha, so nao concede.
// Pedir de novo nao muda nada, entao a UI do recurso fica oculta em vez de
// oferecer um botao que nao tem como funcionar.
//
// ANUNCIOS — App Review do app Facebook Login (1553356899550775) concluida em
// 28/08/2026 com is_approved=false: ads_read, pages_manage_ads, ads_management
// e o Marketing API Access Tier voltaram REJECTED com access_level "none".
// Contas conectadas ate 19/08 ainda carregam os escopos concedidos antes; as
// novas nascem sem eles, e por isso a tela pedia permissao em loop.
//
// Quando a Meta aprovar, basta VITE_META_ADS_ENABLED=true no ambiente — sem
// mexer em codigo. Ausente/qualquer outro valor = recurso oculto.
export const META_ADS_DISPONIVEL = import.meta.env.VITE_META_ADS_ENABLED === 'true';
